import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { RadioButtonItem } from 'components/core/radio-button-group';

export const KIND_QUERY_KEY = 'soort';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseKindReturn = {
	selectedKinds: CheckboxItem[];
	selectedKindsParam: string | (string | null)[] | null | undefined;
	setSelectedKindsParam: (
		newValue: NewValueType<RadioButtonItem | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useKind = (kinds: { id: string | number; name: string }[]): UseKindReturn => {
	const [selectedKindsParam, setSelectedKindsParam] = useQueryParam(KIND_QUERY_KEY, KindArrayParam);
	const selectedKinds = kinds.filter((kind) => selectedKindsParam?.includes(String(kind.id)));

	return {
		selectedKinds: selectedKinds.map((kind) => ({
			id: kind.id,
			label: kind.name
		})),
		selectedKindsParam,
		setSelectedKindsParam
	};
};

export const KindArrayParam: QueryParamConfig<
	RadioButtonItem | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (item) => {
		if (!item?.id) {
			return null;
		}

		return encodeDelimitedArray([item.id.split('-')[1]]);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
